export var SDK_VERSION = '6.3.1';
//# sourceMappingURL=version.js.map